import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { useTranslation } from "react-i18next"

export const ModalEliminarConsigna = ({ show, entry, setEntries }) => {
  const { t } = useTranslation()

  const deleteEntry = useQuery()

  const handleDelete = async () => {
    const { url, opt } = await api.consignas.delete({
      // <- api endpoint
      token: getCookie("jwt"),
      con_id: entry.id, // <- args
    })

    // ejecuto
    deleteEntry.url.current = url
    deleteEntry.opt.current = opt

    deleteEntry.run({
      onOk: () => {
        setEntries((currents) => ({
          ...currents,
          entries: currents.entries.filter((c) => c.id !== entry.id),
        }))
        show[1](false)
      },
    })
  }

  const modalFooter = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => show[1](false)}>
          {t("ui.btns.cancel")}
        </button>

        <button
          type="button"
          className="btn btn-danger"
          disabled={deleteEntry.isPending}
          onClick={() => handleDelete()}>
          {deleteEntry.isPending
            ? `${t("ui.btns.deleting")}...`
            : t("ui.btns.yes")}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="confirmar-accion"
        show={show}
        className="darkie"
        header={<center>{t("ui.msgs.confirm_action")}</center>}
        body={msg(<>{t("modals.modal_delete_consigna.are_you_sure")}</>)}
        footer={modalFooter()}
      />

      {/* en caso de erro, muestro una modal */}
      {deleteEntry.res && deleteEntry.err && (
        <ModalError show={show} res={deleteEntry.res} />
      )}
    </>
  )
}
